<template>
  <div class="bg-darker">
    <b-embed
      type="iframe"
      aspect="16by9"
      :src="url"
      allowfullscreen
    ></b-embed>
  </div>
</template>

<script>
export default {
  computed: {
    url(){
      return this.$store.getters.n_url;
    }
  }
}
</script>